module.exports = __webpack_public_path__ + "assets/img/logo.a5cd303b.png";